export default __webpack_public_path__ + "static/media/logo_bg.528bd441.png";